import api from "./api";
import { APIS } from "../endpoints";

/**
 * Generic Saved Filters API — backend never interprets `filterConfig`, it
 * only stores/returns it verbatim, scoped by an opaque `context` string.
 * See docs/superpowers/plans/2026-08-27-generic-saved-filters.md.
 */

export const getSavedFilters = async (context) => {
  const result = await api.get(`${APIS.BASE_URL}${APIS.savedFilters}`, {
    params: { context },
  });
  return result?.data?.data || { mine: [], public: [] };
};

export const createSavedFilter = async ({
  context,
  name,
  description,
  visibility,
  filterConfig,
}) => {
  const result = await api.post(`${APIS.BASE_URL}${APIS.savedFilters}`, {
    context,
    name,
    description,
    visibility,
    filterConfig,
  });
  return result?.data?.data;
};

export const updateSavedFilter = async (id, payload) => {
  const result = await api.patch(
    `${APIS.BASE_URL}${APIS.savedFilters}/${id}`,
    payload,
  );
  return result?.data?.data;
};

export const deleteSavedFilter = async (id) => {
  const result = await api.delete(`${APIS.BASE_URL}${APIS.savedFilters}/${id}`);
  return result?.data;
};
